import Flatten from "@flatten-js/core"
import { Feature } from 'ol';
import Polygon from 'ol/geom/Polygon';
import { nanoid } from 'nanoid';
import { closePath } from '@Utils/Coordinates.js';
import { doesPolygonsIntersect } from '@Utils/FeatureUtils.js';

export class UnionTool {
	features = []
	constructor(onCompleted) {
		this.onCompleted = onCompleted
	}
	select(feature) {
		let elementType = null
		if (feature.getGeometry().getType() !== 'Polygon') {
			window.dispatchEvent(new CustomEvent('warning', { detail: { message: 'Can only combine polygons', details: 'Union tool' } }))
			return false
		}
		let e = feature.get('elementName')
		if (e === 'green' || e === 'focus' || e === 'tee') {
			window.dispatchEvent(new CustomEvent('warning', { detail: { message: `Cannot combine elements of type ${e}`, details: 'Union tool' } }))
			return false
		}
		if (this.features.length === 1) {
			if (this.features[0] === feature) {
				window.dispatchEvent(new CustomEvent('warning', { detail: { message: 'Cannot select the same feature twice', details: 'Union tool' } }))
				return false
			}
			if (!doesPolygonsIntersect(this.features[0], feature)) {
				window.dispatchEvent(new CustomEvent('warning', { detail: { message: 'Features do not intersect', details: 'Union tool' } }))
				return false
			}
			elementType = this.features[0].get('elementName')
		} else {
			elementType = feature.get('elementName')
		}
		if (elementType !== feature.get('elementName')) {
			window.dispatchEvent(new CustomEvent('warning', { detail: { message: 'Features must be of the same type', details: 'Union tool' } }))
			return false
		}

		feature.set('selected', true)
		this.features.push(feature)
		if (this.features.length === 2) {
			let n = this.flatten(this.features)
			if(n) {
				this.onCompleted(n, [...this.features])
				this.features = []
				return true
			} else {
				feature.set('selected', false)
				this.features.pop()
			}
		}
		return false
	}
	cancel() {
		for (let f of this.features) {
			f.set('selected', false)
		}
		this.features = []
	}
	flatten(features) {
		let f1 = features[0]
		let f2 = features[1]
		let points1 = []
		let points2 = []
		for (let c of f1.getGeometry().getCoordinates()[0]) {
			points1.push(new Flatten.Point(c[0], c[1]))
		}
		for (let c of f2.getGeometry().getCoordinates()[0]) {
			points2.push(new Flatten.Point(c[0], c[1]))
		}

		const p1 = new Flatten.Polygon()
		const face1 = p1.addFace(points1)
		face1.reverse()
		if (face1.orientation() !== Flatten.ORIENTATION.CCW) {
			face1.reverse()
		}

		const p2 = new Flatten.Polygon()
		const face2 = p2.addFace(points2)
		face2.reverse()
		if (face2.orientation() !== Flatten.ORIENTATION.CCW) {
			face2.reverse()
		}
		const p3 = Flatten.BooleanOperations.unify(p1, p2);

		if(p3.faces.size > 1){
			window.dispatchEvent(new CustomEvent('warning', { detail: { message: 'These two features will result in a polygon with a hole in it which is unsupported', details: 'Union tool' } }))
			return null
			/*if (!confirm('The new feature will have a hole in it w')) {
				return
			}*/
		}
		const face = [...p3.faces][p3.faces.size -1]
		const vertices = [...face.edges].map(edge => edge.start)

		let coordinates = []
		for (let v of vertices) {
			coordinates.push([v.x, v.y])
		}
		coordinates = closePath(coordinates)
		let feature = new Feature(new Polygon([coordinates]))
		let props = f1.getProperties()
		feature.set('elementName', props.elementName)
		feature.set('uid', nanoid())
		feature.set('order', props.order)
		if (props.holeId) {
			feature.set('holeId', props.holeId)
		}
		if (props.placeabove !== undefined) {
			feature.set('placeabove', props.placeabove)
		}
		if (props.rounded !== undefined) {
			feature.set('rounded', props.rounded)
		}
		if (props.normalize !== undefined) {
			feature.set('normalize', props.normalize)
		}
		if (props.pointsPerSeg !== undefined) {
			feature.set('pointsPerSeg', props.pointsPerSeg)
		}
		if (props.tension !== undefined) {
			feature.set('tension', props.tension)
		}
		console.warn('fetch all valid properties and merge')
		return feature
	}
}